/**
 * Static copy and styling constants for the AI chatbot (Fae).
 */

/** PII disclaimer – shown persistently in chat header/section */
export const PII_DISCLAIMER =
    "Please don't include personal or identifiable information in your messages. Use the tools below the chat to select a class or student.";

/** AI-output disclaimer – shown persistently in chat header/section */
export const AI_DISCLAIMER =
    'Fae is AI-generated and may not be fully accurate — please review responses before actioning.';

/** Same blue gradient as Fae header – use for chatbot, messages, chips, buttons */
export const headerGradient =
    'linear-gradient(135deg, var(--color-primary-dark, #0d47a1) 0%, var(--color-primary, #1976d2) 100%)';

/** Assistant (Fae) avatar – gradient circle with robot icon */
export const assistantAvatarSx = {
    width: 32,
    height: 32,
    flexShrink: 0,
    background: headerGradient,
    color: 'white',
};

export const INITIAL_MESSAGE = {
    id: 'initial',
    role: 'assistant',
    content: `Hello! I'm Fae, your AI assistant. I'm here to help answer questions about your school's data and wellbeing insights.

What would you like to know?`,
    timestamp: new Date(),
};

export const SUGGESTIONS = [
    {
        text: 'What emotions were the most common this term?',
        prompt: 'What emotions were the most common for students to check-in with this term',
    },
    {
        text: 'What is the weekly engagement rate for our students?',
        prompt: 'What is the weekly engagement rate for our students?',
    },
];

// export const SUGGESTIONS = [
//     {
//         text: 'What is the weekly engagement rate for our students?',
//         prompt: 'What is the weekly engagement rate for our students?',
//     },
//     {
//         text: 'How does student readiness compare this week vs last week?',
//         prompt: 'How does student readiness compare this week vs last week?',
//     },
//     {
//         text: 'What emotions were the most common this term?',
//         prompt: 'What emotions were the most common for students to check-in with this term',
//     },
// ];
